import { useState } from "react";

export const RowTable = ({ dataRow, maxChildren, maxOccupation }) => {

  const {
    start_date,
    end_date,
    roomData
  } = dataRow;

  const [roomDataSet, setRoomDataSet] = useState(roomData);

  return (
    <>
      {roomDataSet.map((room, index) => {
        const {allot, occupation_type, adults, release, extra_pax, children, infants, room_type} = room;
        return (
          <tr key={index}>
            <th scope='rowgroup' className='text-center'>{start_date}</th>
            <th scope='rowgroup' className='text-center'>{end_date}</th>
            <th scope='row'>{room_type}</th>
            <td>{allot}</td>
            <td>{release}</td>
            {occupation_type && occupationTypeRow(occupation_type, maxOccupation)}
            <td>{adults}</td>
            {children && guestTypeRow(children, maxChildren)}
            <td>{infants ? infants : 0}</td>
            <td>{extra_pax}</td>
          </tr>
        )
      })}
    </>
  )
}

const occupationTypeRow = (occupation_type, maxOccupation) => {
  if (occupation_type.length < maxOccupation) {
    const diff = maxOccupation - occupation_type.length;
    for (let i = 0; i < diff; i++) {
      occupation_type.push('0')
    }
  }
  return occupation_type.map((occ, index) => <td key={index}>{occ}</td>)
}

const guestTypeRow = (children, maxChildren) => {
  if (children.length < maxChildren) {
    const diff = maxChildren - children.length;
    for (let i = 0; i < diff; i++) {
      children.push('0')
    }
  }
  return children.map((child, index) => <td key={index}>{child}</td>)
}